import { render, staticRenderFns } from "./summaryPbTable.vue?vue&type=template&id=797993b3"
import script from "./summaryPbTable.vue?vue&type=script&lang=js"
export * from "./summaryPbTable.vue?vue&type=script&lang=js"
import style0 from "./summaryPbTable.vue?vue&type=style&index=0&id=797993b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports